// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"000efc4d","64":"ab2facdf","276":"cac06505","455":"088282bf","492":"ffd149ce","633":"60cc15f5","643":"a9222a8e","702":"4ab68927","741":"5bd8883a","748":"3536d4c5","768":"135ce816","797":"d4a28378","836":"5ac63be3","988":"42024d8b"}[chunkId] + ".chunk.js";
};